






























import {
  Component,
  Vue
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import HsabExpenseCardRow from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRow.vue";
import HsabExpenseCardColumns from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardColumns.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    HsabExpenseCardColumns,
    HsabExpenseCardRow,
    Paginator,
    GenericLoadingSpinner
  }
})
export default class ManagedExpenseTable extends Vue {
  managedExpensesStore = useManagedExpenseStore();
  hsabAccountStore = useHsabAccountsStore();

  get showPlanNameColumn () {
    return this.hsabAccountStore.userHasAnyNotionalAccounts;
  }

  get currentPage () {
    return this.managedExpensesStore.currentPageNumber;
  }

  get pageCount () {
    return this.managedExpensesStore.totalPageCount;
  }

  get hasPages () {
    return this.managedExpensesStore.totalPageCount > 0;
  }

  get loaded () {
    return this.managedExpensesStore.isCurrentPageLoaded;
  }

  get loading () {
    return this.managedExpensesStore.isCurrentPageLoading;
  }

  get items () {
    return this.managedExpensesStore.currentPageItems;
  }

  onSwitchPage (pageNumber: number) {
    this.managedExpensesStore.loadManagedExpensesByPage(pageNumber);
  }
}
